// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import store from "./store";
import 'babel-polyfill'
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';
import '@/permission'

import * as service from '@/utils/request';
import moment from 'moment';
// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, /* { default global options } */)


//包装请求参数 传输json格式的数据需要进行一层包装 使用方式
import qs from 'qs'
import 'jquery'
import "swiper/swiper.scss";

Vue.prototype.$qs = qs;
Vue.config.productionTip = false
Vue.prototype.$moment = moment;
Vue.prototype.service = service;
Vue.prototype.imgUrl='/imgUrl';



//刷新保存状态
if (sessionStorage.getItem("store")) {
  store.replaceState(
    Object.assign(
      {},
      store.state,
      JSON.parse(sessionStorage.getItem("store"))
    )
  );
  sessionStorage.removeItem("store")
}

//监听，在页面刷新时将vuex里的信息保存到sessionStorage里
window.addEventListener("beforeunload", () => {
  sessionStorage.setItem("store", JSON.stringify(store.state));
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js